import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

import styled from '@xstyled/styled-components';
import { Radio, Space } from 'antd';
import { BaseQuestionPreview } from '../base-question';
import { MathEnabledTextComponent, styleVariables } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
var AnswerItem = styled(Radio)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  flex: 1;\n  span.ant-radio + * {\n    flex: 1;\n    height: auto;\n    padding-right: 0;\n  }\n  .ant-radio-inner::after {\n    background-color: ", ";\n  }\n  .ant-radio-checked .ant-radio-inner {\n    border-color: ", ";\n  }\n  .ant-input-affix-wrapper {\n    border-radius: 4px !important;\n    border-color: ", ";\n  }\n"])), styleVariables.colors.blue3, styleVariables.colors.blue4, styleVariables.colors.gray8);
var AnswerContainer = styled(Space)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var AnswerGroup = styled(Radio.Group)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var AnswerDescription = styled(MathEnabledTextComponent)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), styleVariables.colors.gray11);
var AnswerItemLayout = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n"])));
export var SingleChoicePreview = function SingleChoicePreview(props) {
  var question = props.question,
      index = props.index,
      disabled = props.disabled,
      active = props.active;
  return /*#__PURE__*/_jsx(BaseQuestionPreview, {
    index: index,
    question: question,
    active: active,
    children: /*#__PURE__*/_jsx(AnswerGroup, {
      disabled: disabled,
      value: question.correctAnswers[0].answerId,
      children: /*#__PURE__*/_jsx(AnswerContainer, {
        direction: "vertical",
        size: "middle",
        children: question.answers.map(function (a, index) {
          return /*#__PURE__*/_jsx(AnswerItemLayout, {
            children: /*#__PURE__*/_jsx(AnswerItem, {
              value: a.id.toString(),
              disabled: true,
              children: /*#__PURE__*/_jsx(AnswerDescription, {
                value: a.description
              })
            }, index)
          }, index);
        })
      })
    })
  });
};